import React from "react";
import { useAppConfig } from "@ct-react/core";
import { SiteType } from "@shared/site-type";
import RentalpSvg from "../../assets/rentalp-logo.svg";
import SeasonalpSvg from "../../assets/seasonalp-logo.svg";

const SiteLogo = () => {
  const { options: { siteType } } = useAppConfig();
  return siteType === SiteType.SEASONALP ? <SeasonalpSvg className="logo" /> : <RentalpSvg className="logo" />;
}

export default SiteLogo;
